<div
  class="table-card"
  [ngClass]="{
    'table-card--available': status === 1,
    'table-card--occupied': status === 2,
    'table-card--locked': status === 3,
    'table-card--reserved': status === 4
  }">
  <div
    class="table-card__number"
    [ngClass]="{
      'table-card__number--ltr': !language.isArabic,
      'table-card__number--rtl': language.isArabic
    }">
    <p>{{ tableNumber }}</p>
  </div>
  <div class="table-card__body">
    <div class="table-card__image-wrap">
      <img *ngIf="status === 1" src="assets/images/emptyTable.png" alt="" />
      <img *ngIf="status === 2" src="assets/images/accptedOrder.png" alt="" />
      <img *ngIf="status === 3" src="assets/images/lockTable.svg" alt="" />
      <img *ngIf="status === 4" src="assets/images/ReservedTable.png" alt="" />
    </div>
    <div class="table-card__status">
      <p>{{ title | formatType }}</p>
    </div>
  </div>
</div>
